import { acceptRatingValue } from '../../field-viewer/shared-normalizers';
export const ratingInputViewer = {
    normalizeLoadedValue: acceptRatingValue
};

//# sourceMappingURL=definition-viewer.js.map